
<div class="p-2 pb-14 flex-1 h-full  overflow-y-auto">
<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="userProfileForm">
        <div class=" flex flex justify-between">
            <h1 class="heading">
                Profile
            </h1>
            <button type="button" class="btn btn-secondary" (click)="resetPassword()">
                Reset Password
            </button>
        </div>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 sm:grid-cols-2">
            <div class="space-y-1">
                <label class="subheading">
                 Name
                </label>
                <div>
                    <div>
                        <input formControlName="name" type="text" readonly />
                    </div>
                   
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Email
                </label>
                <div>
                    <div>
                        <input formControlName="email" type="email" readonly />
                    </div>
                   
                </div>
            </div>
            <div class="col-span-full space-y-1">
                <label class="subheading">
                    Profile Image
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                            <!-- Display the profile logo or a placeholder -->
                            <img src="{{profileImageURL ? profileImageURL : 'assets/images/company-placeholder.png' }}"
                                alt="Profile Image" class="relative h-32 w-32 rounded-full border border-main-base" />
                            <label for="Profile"
                                class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                <span>Change</span>
                                <input #logoInput type="file" accept="image/*" style="width: 100%;" [hidden]="true"
                                    (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                    class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </form>
</div>
</div>